import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { CapabilityCheck, CapabilityCheckRequest } from '../../../models';

@Injectable({
  providedIn: 'root',
})
// Capable-to-promise at order entry. The check itself is recorded server-side, because a
// promise is a commitment - re-running it later would answer against later stock.
// Extends the EDIT base so the recorded checks can be listed and opened with the standard
// search-grid/edit-form pair. There is no Save: a check is produced by running one, never
// typed in - hence Edit, not EditCreate.
export class CapabilityCheckService extends TmsWebBaseEditService<CapabilityCheck, CapabilityCheck> {
  constructor() {
    super('CapabilityCheck', $localize`Capability Check`);
  }

  check(request: CapabilityCheckRequest): Observable<CapabilityCheck> {
    return this.httpService.post<CapabilityCheck>(`${this.apiUrl}/Check`, request);
  }

  // Turns an accepted check into a production order and line.
  accept(capabilityCheckResultId: string): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/Accept/${capabilityCheckResultId}`, {});
  }
}
